import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getStatusMappingModuleName } from './status-mapping-management.permissions';

export class StatusMappingPermissions {
  static GroupName = `${getStatusMappingModuleName()}.StatusMapping`;

  static getPermissions = getGroupPermissionFactory(StatusMappingPermissions.GroupName);

  static Permissions = {
    Create: StatusMappingPermissions.getPermissions(PermissionEnum.CREATE),
    Read: StatusMappingPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: StatusMappingPermissions.getPermissions(PermissionEnum.READ_ALL),
    Update: StatusMappingPermissions.getPermissions(PermissionEnum.UPDATE),
  };
}
